import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

// 列表
async function all (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match/${data.matchId}/session`,
      method: 'GET'
    }
  )
}

async function getById (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match/${data.matchId}/session/${data.id}`,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match/${data.matchId}/session`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match//${data.matchId}/session/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match//${data.matchId}/session/${data.id}`,
      method: 'DELETE'
    }
  )
}

// 获取报名数量
async function getEntryValueCount (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match/${data.matchId}/session/${data.sessionId}/entryValueCount`,
      method: 'GET'
    }
  )
}

export default {
  all,
  getById,
  insert,
  update,
  remove,
  getEntryValueCount
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-competition-stage-match-session.js